import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscontrolstruct(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
        
        <Helmet>
 
 <title>Learn Free JavaScript Control Structure Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript control Structure tutorial for beginners control Structure in Javascript is a program is executed as per requirement according to requirement the sequence can be changed by using the control structure statement provides Multiple Programming Examples for Beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript control Structure,Javascript control Structure for,Javascript control Structure for loop,end for loop Javascript,Javascript exit for loop,exit while loop Javascript,control Structure foreach Javascript,control structure in javascript,javascript control structures quizlet" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-control-structure" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Control Structure Statement in Javascript</h1>
    <div className="first">
        <a href="/javascript-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-3 mh2">Types of control structure statement in Javascript</h2>

    <p className="mt-4 para"> The program Executes according to requirements. The sequence can be changed using the control structure statement. The categories and keywords Show below:
</p>
    
<h2 className="mt-4 mh2">The Conditional statement is many types in Javascript:<br/></h2>

<h4 className="mt-4 mh3">If-condition <br/>
If-else<br/>
If-else-if<br/>
Nested if<br/>
Switch-case
</h4>
<h2 className="mt-4 mh2">Javascript looping (iteration)<br/></h2>
<h3 className="mt-4 mh3">There are three types of looping in Javascript:<br/>
</h3>
<h4 className="mt-4">While loop<br/>
Do-while loop<br/>
For loop<br/>
</h4>
<h2 className="mt-4 mh2">Jumping statements in Javascript:<br/></h2>

<h3 className="mt-4 mh3">Continue<br/>
Break

</h3>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cscontrolstruct;